import { render, staticRenderFns } from "./OpenVpnList.vue?vue&type=template&id=78303ac0&scoped=true&"
import script from "./OpenVpnList.vue?vue&type=script&lang=js&"
export * from "./OpenVpnList.vue?vue&type=script&lang=js&"
import style0 from "./OpenVpnList.vue?vue&type=style&index=0&id=78303ac0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78303ac0",
  null
  
)

export default component.exports